module.exports = __webpack_public_path__ + "static/assets/6c741312f482b406f27c1422fac11c97.svg";